import React from "react";
import {NavLink} from "react-router-dom";

import '../../../css/styles.css';

export default function AboutUs(props) {

    return (
      <div
        key="main_page_about_us"
        className="slider-wrapper slider-content slide slide-about main-about current "
        style={{ background: `url('${props.aboutUsImage}') no-repeat center center` }}
      >
        <div className="inner">
          <h1>O nás</h1>
          <p>Kdo jsme, v co věříme a k čemu vedeme.</p>
          <button>
            <NavLink to= "/about">
              Číst dále
            </NavLink>
          </button>
          </div>
      </div>
    );

}
